module.exports = __webpack_public_path__ + "img/background-769.83e60c40.jpg";